import { jsx as i, jsxs as m } from "react/jsx-runtime";
import u from "clsx";
import o from "./InputErrorMessage.module.css.js";
import { ErrorIcon as l } from "../../foundations/icons/Error.js";
const p = (s) => typeof s == "object" && s !== null, f = (s) => p(s) && typeof s.message == "string" && typeof s.id == "string", g = (s) => Array.isArray(s) && s.every(f), c = (s, e) => {
  if (s === null)
    return [];
  if (g(s))
    return s;
  const n = typeof s == "string" ? [s] : s;
  return [...new Set(n)].map((t, r) => ({
    message: t,
    id: [e, r].filter((a) => a !== void 0).join("-")
  }));
}, x = ({ children: s, id: e, className: n }) => {
  if (s === null)
    return null;
  const t = c(s, e);
  return t.length === 0 ? null : (
    // setting aria-live="assertive" on the container of errors, to ensure screen readers will read all error messages
    /* @__PURE__ */ i("div", { "aria-live": "assertive", className: u([o.multiErrorContainer, n]), children: t.map(
      (r) => !!r.message && /* @__PURE__ */ m("div", { className: o.error, id: `${r.id}`, children: [
        /* @__PURE__ */ i("div", { className: o.iconContainer, children: /* @__PURE__ */ i(l, {}) }),
        r.message
      ] }, `${r.id}`)
    ) })
  );
};
export {
  x as InputErrorMessage
};
//# sourceMappingURL=InputErrorMessage.js.map
